module.exports = __webpack_public_path__ + "static/media/Element_4_treatments.ae4738fd.svg";